import React from "react";
import PieChart from "highcharts-react-official";
import Highcharts from "highcharts";
import { thisBaseURL } from "../../utils/helper.js";
require("highcharts/modules/accessibility")(Highcharts);

function ClimateLandUse({countryAnswers}){
	let defaultCountry = countryAnswers.answerKeyValues["country_code"];
	let climateClassification = countryAnswers.answerKeyValues['climate_classification'];
	let climateNotes = countryAnswers.answerKeyValues['climate_classification_notes'];
	let climateSourceRef = countryAnswers.answerKeyValues['climate_classification_sources'];
	let climateYear = countryAnswers.answerKeyValues['climate_classification_year'];
	
	let array = [];
	let dataSeries = {};
	if(climateClassification){
		try {
			array =  JSON.parse(climateClassification);
		} catch (err) {
			console.log("ClimateLandUse :climateClassification: " +err);
		}
		dataSeries = array.map(function (obj) {
			if(obj && obj["koppen_geiger_climate_zones"] && obj["land_area_"]){
				return {"name": obj["koppen_geiger_climate_zones"], "y": parseFloat(obj["land_area_"])};
			}
		});
	}
	
	return(
		<div className="question-grouping" id="climate_and_land_use">
			<h2>Climate and Land Use</h2>
			<h2 style={{textAlign: "center"}}>
				Climate Breakdown
				{climateYear ? 
				<small>&nbsp;({climateYear})</small>
				: ""}
				{ climateSourceRef && climateSourceRef > 0 ?
				<small className="superscript"><a href={thisBaseURL +"/countries/" + defaultCountry +"#"+climateSourceRef}>{climateSourceRef}</a></small> :
				""
				}
			</h2>
			
			<PieChart highcharts={Highcharts} containerProps={{ style: { width: "60vw" } }}
			options={{
				title: {
					text: ''
				},
				credits: {
					enabled: false
				},
				lang: {
					thousandsSep: ','
				},
				chart: {
					plotBackgroundColor: null,
					plotBorderWidth: null,
					plotShadow: false,
					type: "pie"
				},
				tooltip: {
					pointFormat: '{series.name}: <b>{point.percentage:.2f}%</b>'
				},
				plotOptions: {
					pie: {
						allowPointSelect: true,
						cursor: 'pointer',
						dataLabels: {
							enabled: true,
							format: '<b>{point.name}</b>: {point.percentage:.2f} %',
							style: {
								color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
							}
						}
					}
				},
				series: [{
					name: "Breakdown",
					colorByPoint: true,
					data: dataSeries
				}]
			}}
			/>
			<br />
			<br />
			{climateNotes ? 
			<p className="notes-info" style={{marginTop:"-20px"}} >
				<em>{climateNotes}</em>
			</p>
			: ""}
		</div>
	)
}
export default ClimateLandUse;